import React, { Component } from "react";
import FpgMinusIcon from "../../icons/fpgminusicon";
import FpgPlusIcon from "../../icons/fpgplusicon";
import DraggerIcon from "../../icons/draggericon";
import CatEditIcon from "../../icons/catediticon";
import TextField from "../../component/TextField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//sweet alert
import swal from "sweetalert";

//Service import
import service from "../../services";
import Loader from "../../component/loader";
import Tablist from "./Tablist";

let sub;

class PafFilmCredit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addCatmodal: false,
            name: "",
            description: "",
            loaderFlag: false,
            isDraggable: false,
            changeCreditLebelTitleName: false,
            getAllCreditLebelDetails: [],
            getAllCreditLebelDocs: [],
            id: "",
            isDraggable: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                Creditname: {  // name the rule
                    message: 'Credit Name is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                description: {  // name the rule
                    message: 'Credit Description is required. ',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        })
        this.apiserve = new service();
        this.tablistRef = React.createRef();
    }
    AddCategory = () => {
        this.setState({
            addCatmodal: true,
            name: "",
            description: "",
        });
    };
    CloseModal = () => {
        this.setState({
            addCatmodal: false,
            name: "",
            description: "",
            changeCreditLebelTitleName: false,
            id: ''
        });
        this.validator.hideMessages("");
    };
    componentDidMount = async () => {
        this.getAllCreditLebel();
        this.getcreditlebel();
        this.setState({
            loaderFlag: true,
        });
    };

    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    getcreditlebel = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "paf|filmCreditLable|getRefValue":
                    this.setState(
                        {
                            getAllCreditLebelDetails: response.data,
                            getAllCreditLebelDocs: response.data.docs,
                        },
                        () => {
                            this.setState({
                                loaderFlag: false,
                            });
                            if (this.tablistRef.current) this.tablistRef.current.updatedAt();
                        }
                    );
                    break;
                case "paf|filmCreditLable|add":
                    if (response.error === true) {
                        this.setState({
                            loaderFlag: false,
                            errorMsg: true,
                            errorMsgShow: response.data.error,
                        });
                    } else {
                        this.setState(
                            {
                                addCatmodal: false,
                            },
                            this.setState({
                                loaderFlag: false,
                                name: "",
                                description: "",
                                changeCreditLebelTitleName: false,
                            }),
                            this.apiserve.success("Credit Label created successful.")
                        );
                    }
                    this.getAllCreditLebel();
                    break;
                case "paf|filmCreditLable|update":
                    if (response.error === true) {
                        this.setState({
                            loaderFlag: false,
                            errorMsg: true,
                            errorMsgShow: response.data.error,
                        });
                    } else {
                        this.setState(
                            {
                                addCatmodal: false,
                                changeCreditLebelTitleName: false,
                            },
                            this.setState({ loaderFlag: false }),

                            this.apiserve.success("Credit Label updated Successful.")
                        );
                    }
                    this.getAllCreditLebel();
                    break;
                case "paf|filmCreditLable|remove":
                    this.getAllCreditLebel();
                    break;
                case "paf|filmCreditLable|changeOrder":
                    break;
            }
        });
    };

    getAllCreditLebel = () => {
        this.apiserve.sendevent("paf|filmCreditLable|getRefValue", {});
    };

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    submitFn = async (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true });
            if (this.state.changeCreditLebelTitleName) {
                let updatecreditLabel = {
                    name: this.state.name,
                    description: this.state.description,
                    creditLableId: this.state.id,
                };
                this.apiserve.sendevent("paf|filmCreditLable|update", updatecreditLabel);
            } else {
                let data = {
                    name: this.state.name,
                    description: this.state.description,
                };
                this.apiserve.sendevent("paf|filmCreditLable|add", data);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    editCreditLebeUser = async (item) => {
        this.setState({
            addCatmodal: true,
            changeCreditLebelTitleName: true,
            name: item.name,
            description: item.description,
            id: item._id,
        });
    };

    deleteCreditLebeUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                swal("Your record has been deleted!", {
                    icon: "success",
                });
                let data = {
                    creditLableId: item._id,
                };
                this.apiserve.sendevent("paf|filmCreditLable|remove", data);
            } else {
                swal("Your record is safe!");
            }
        });
    };

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.getAllCreditLebelDocs];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                creditLableId: _id,
                sortIndex: i + 1,
            });
        });
        this.setState({ isDraggable: true });
        const data = { order: updateArr };
        this.apiserve.sendevent("paf|filmCreditLable|changeOrder", data);
        this.setState({ getAllCreditLebelDocs: arr });
    };

    validateModel = () => {
        this.setState({
            errorMsg: false,
        });
    };
    render() {
        const { getAllCreditLebelDocs, changeCreditLebelTitleName } = this.state;
        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <Tablist activeNF='FILMS' name='PafFilmCredit' ref={this.tablistRef} />
                    <div className="cat_outer_content">
                        <div className="category_add_edit">
                            <div className="category_header relative">
                                <p>Credits </p>
                                <span className="add_icon d_flex" onClick={this.AddCategory}>
                                    <FpgPlusIcon
                                        width="16"
                                        height="16"
                                        color="#ffffff"
                                        stroke="#4F4F4F"
                                    />
                                </span>
                            </div>
                            <div className="list_wrap striped_droppable_table">
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided, snapshot) => (
                                            <ul
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                            >
                                                {getAllCreditLebelDocs?.map((item, index) => (
                                                    <Draggable
                                                        key={item._id}
                                                        draggableId={item._id}
                                                        index={index}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <li
                                                                className="pointer d_flex d_flex_align_center"
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <span className="cat_drag d_flex">
                                                                    <DraggerIcon />
                                                                </span>
                                                                <p className="cat_name">{item.name}</p>
                                                                <div className="action d_flex d_flex_align_center">
                                                                    <span
                                                                        className="cat_edit pointer"
                                                                        onClick={() =>
                                                                            this.editCreditLebeUser(item)
                                                                        }
                                                                    >
                                                                        <CatEditIcon />
                                                                    </span>
                                                                    <span
                                                                        className="remove_cat pointer"
                                                                        onClick={() =>
                                                                            this.deleteCreditLebeUser(item)
                                                                        }
                                                                    >
                                                                        <FpgMinusIcon
                                                                            width="16"
                                                                            height="16"
                                                                            color="#4F4F4F"
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        )}
                                                    </Draggable>
                                                ))}
                                            </ul>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
                    >
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="cat_modal_inner">
                            <p className="cat_title text_center">
                                {changeCreditLebelTitleName
                                    ? "Edit Credit"
                                    : "Credit"}
                            </p>
                            <form>
                                <div className="field_row horizontal_field d_flex">
                                    <TextField
                                        type="text"
                                        label="Credit Name"
                                        name="name"
                                        value={this.state.name}
                                        onChange={this.onInputChange}
                                        fpgerror={this.validator.message("Credit Label",this.state.name,"Creditname|required")}
                                    />
                                    {/* <span style={{ color: "red" }}>
                    {this.validator.message(
                      "Credit Label",
                      this.state.name,
                      "required"
                    )}
                  </span> */}
                                </div>
                                <div className="field_row horizontal_field d_flex">
                                    <label>Credit Description</label>
                                    <div className="textarea_wrap">
                                        <textarea
                                            type="text"
                                            rows="12"
                                            name="description"
                                            value={this.state.description}
                                            onChange={this.onInputChange}
                                        ></textarea>
                                        <span style={{ color: "red" }}>
                                            {this.validator.message("Description",this.state.description,"description|required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="cat_btns text_center">
                                    <button type="button" onClick={this.CloseModal}>
                                        CANCEL
                                    </button>
                                    <button
                                        className="active"
                                        onClick={(e) => this.submitFn(e)}
                                    >
                                        SAVE
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
                    <span className="popup_overlay"></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>{this.state.errorMsgShow}</p>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button
                                    className="small_btn active"
                                    onClick={this.validateModel}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loaderFlag ? <Loader /> : ""}
            </React.Fragment>
        );
    }
}

export default PafFilmCredit;
